import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { createContractLink } from "@app/conf/appLink";
import { environment } from '@env/environment';
import { HttpService } from '@app/Modules/Shared/Services/http.service';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';

@Component({
  selector: 'app-hyperlink',
  templateUrl: './hyperlink.component.html',
  styleUrls: ['./hyperlink.component.scss']
})
export class HyperlinkComponent implements AgRendererComponent {
  enableHyperlink: boolean;
  userId: string;
  region: string;
  loggedInCountry: string;
  isUnrestricedCountry: boolean = false;
  constructor(private httpServ: HttpService,private _appServ: AppService,private _globalAppService: GlobalAppService) { }
  params: any;  

  agInit(params: any): void {
    this.userId = this._appServ.getuserId(true);
    this.region = this._globalAppService.getDefaultRegionString();
    this.loggedInCountry = this._globalAppService.getDefaultCountryString();
    this.isUnrestricedCountry = this.loggedInCountry == 'AU' || this.loggedInCountry == 'NZ' || this.loggedInCountry == 'TH';
    this.params = params;
    if(this.region == 'APAC' && this.params && this.params.data){
      if (!this.isUnrestricedCountry){
        this.enableHyperlink = this.params.data.oppty_Access === "1";
      } else {
        this.enableHyperlink = true;
      }
    }
  }

  refresh(params: any): boolean {
    return false;
  }

  onLinkClick(event) {
    if (!environment.spartaEncryption) {
      let redirectUrl: string = createContractLink.createContractURI + this.params.data.contractNumber;
      window.open(redirectUrl, '_blank');
    }
    else {
      let spartaURL = this.httpServ.getRegionSpecificURL(environment.spartaModifyPAURL);
      if(this.params && this.params.data){
        let encryptedContractNumber = this.params.data.encryptedcontractnumber;
        spartaURL = spartaURL.replace('####', encryptedContractNumber);
      }
      window.open(spartaURL, '_blank');
    }
  }

}
